const replaceNumber = (number) => {
  return number.replace(/[^0-9+#]/g, "").replace(/(\..*)\./g, "$1");
};

export default replaceNumber;
